import cn from '@config/tailwind/cn'

function AspectRatio({ ratio, className, ...props }: React.ComponentProps<'div'> & { ratio: number }) {
  return (
    <div
      data-slot='aspect-ratio'
      style={
        {
          '--ratio': ratio,
        } as React.CSSProperties
      }
      className={cn('ui:relative ui:aspect-(--ratio)', className)}
      {...props}
    />
  )
}

export { AspectRatio }
